/** Added-word tint shared by the routine card and the draft card. */
export const changeTintClassName =
  'rounded-xs bg-entity-green-muted box-decoration-clone px-0.5';

/** Removed-word tint for a draft that only deletes text. */
export const removalTintClassName =
  'rounded-xs bg-entity-red-muted box-decoration-clone px-0.5 line-through';
